export default __webpack_public_path__ + "static/media/circle-step-pending.0977aa60.svg";